import * as React from "react";
import type { SVGProps } from "react";

const SvgHsaPerksDashboard = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    width={20}
    height={20}
    viewBox="0 0 20 20"
    {...props}
  >
    <defs>
      <path id="hsa-perks-dashboard_svg__a" d="M0 0h6v2H0z" />
      <path id="hsa-perks-dashboard_svg__c" d="M0 0h6v2H0z" />
      <path id="hsa-perks-dashboard_svg__e" d="M0 0h6v2H0z" />
      <path id="hsa-perks-dashboard_svg__g" d="M0 0h6v2H0z" />
      <path id="hsa-perks-dashboard_svg__i" d="M0 0h6v2H0z" />
      <path id="hsa-perks-dashboard_svg__k" d="M0 0h6v2H0z" />
    </defs>
    <g fill="none" fillRule="evenodd">
      <path
        fill="currentColor"
        d="M5 20H1c-.55 0-1-.45-1-1s.45-1 1-1h4c.55 0 1 .45 1 1s-.45 1-1 1m7 0H8c-.55 0-1-.45-1-1s.45-1 1-1h4c.55 0 1 .45 1 1s-.45 1-1 1"
      />
      <g transform="translate(14 18)">
        <mask id="hsa-perks-dashboard_svg__b" fill="#fff">
          <use xlinkHref="#hsa-perks-dashboard_svg__a" />
        </mask>
        <path
          fill="currentColor"
          d="M5 2H1c-.55 0-1-.45-1-1s.45-1 1-1h4c.55 0 1 .45 1 1s-.45 1-1 1"
          mask="url(#hsa-perks-dashboard_svg__b)"
        />
      </g>
      <path
        fill="currentColor"
        d="M5 17H1c-.55 0-1-.45-1-1s.45-1 1-1h4c.55 0 1 .45 1 1s-.45 1-1 1m7 0H8c-.55 0-1-.45-1-1s.45-1 1-1h4c.55 0 1 .45 1 1s-.45 1-1 1"
      />
      <g transform="translate(14 15)">
        <mask id="hsa-perks-dashboard_svg__d" fill="#fff">
          <use xlinkHref="#hsa-perks-dashboard_svg__c" />
        </mask>
        <path
          fill="currentColor"
          d="M5 2H1c-.55 0-1-.45-1-1s.45-1 1-1h4c.55 0 1 .45 1 1s-.45 1-1 1"
          mask="url(#hsa-perks-dashboard_svg__d)"
        />
      </g>
      <path
        fill="currentColor"
        d="M5 14H1c-.55 0-1-.45-1-1s.45-1 1-1h4c.55 0 1 .45 1 1s-.45 1-1 1m0-3H1c-.55 0-1-.45-1-1s.45-1 1-1h4c.55 0 1 .45 1 1s-.45 1-1 1"
      />
      <g transform="translate(14 9)">
        <mask id="hsa-perks-dashboard_svg__f" fill="#fff">
          <use xlinkHref="#hsa-perks-dashboard_svg__e" />
        </mask>
        <path
          fill="currentColor"
          d="M5 2H1c-.55 0-1-.45-1-1s.45-1 1-1h4c.55 0 1 .45 1 1s-.45 1-1 1"
          mask="url(#hsa-perks-dashboard_svg__f)"
        />
      </g>
      <g transform="translate(14 6)">
        <mask id="hsa-perks-dashboard_svg__h" fill="#fff">
          <use xlinkHref="#hsa-perks-dashboard_svg__g" />
        </mask>
        <path
          fill="currentColor"
          d="M5 2H1c-.55 0-1-.45-1-1s.45-1 1-1h4c.55 0 1 .45 1 1s-.45 1-1 1"
          mask="url(#hsa-perks-dashboard_svg__h)"
        />
      </g>
      <g transform="translate(14 3)">
        <mask id="hsa-perks-dashboard_svg__j" fill="#fff">
          <use xlinkHref="#hsa-perks-dashboard_svg__i" />
        </mask>
        <path
          fill="currentColor"
          d="M5 2H1c-.55 0-1-.45-1-1s.45-1 1-1h4c.55 0 1 .45 1 1s-.45 1-1 1"
          mask="url(#hsa-perks-dashboard_svg__j)"
        />
      </g>
      <path
        fill="currentColor"
        d="M12 14H8c-.55 0-1-.45-1-1s.45-1 1-1h4c.55 0 1 .45 1 1s-.45 1-1 1"
      />
      <g transform="translate(14 12)">
        <mask id="hsa-perks-dashboard_svg__l" fill="#fff">
          <use xlinkHref="#hsa-perks-dashboard_svg__k" />
        </mask>
        <path
          fill="currentColor"
          d="M5 2H1c-.55 0-1-.45-1-1s.45-1 1-1h4c.55 0 1 .45 1 1s-.45 1-1 1"
          mask="url(#hsa-perks-dashboard_svg__l)"
        />
      </g>
      <path
        fill="currentColor"
        d="M11.337 4.538c-.379-.219-.782-.382-1.181-.555a2.5 2.5 0 0 1-.648-.377c-.384-.32-.311-.834.142-1.037.127-.056.26-.076.398-.087a2.95 2.95 0 0 1 1.495.306c.236.116.315.081.394-.173.084-.27.152-.54.231-.809.049-.183-.011-.3-.178-.376a3.6 3.6 0 0 0-.938-.29c-.428-.072-.428-.072-.428-.514C10.618 0 10.618 0 10.014 0h-.266c-.285.011-.334.061-.339.356-.005.132 0 .265 0 .397 0 .391-.005.387-.369.524-.88.33-1.421.951-1.479 1.944-.055.875.387 1.469 1.087 1.902.426.264.904.422 1.356.631.177.081.345.173.497.3.438.371.358.997-.162 1.231a1.56 1.56 0 0 1-.871.117 3.8 3.8 0 0 1-1.327-.412c-.246-.133-.316-.097-.399.178-.074.239-.137.478-.201.717-.084.32-.055.397.24.549.379.189.783.286 1.196.357.324.051.334.065.339.417q-.001.236.004.473c0 .198.094.315.29.315.227.005.448.005.674 0 .182-.005.281-.106.281-.3 0-.214.009-.432 0-.646-.01-.219.084-.33.285-.387a2.25 2.25 0 0 0 1.175-.778c.851-1.083.521-2.651-.688-3.347"
      />
    </g>
  </svg>
);
export default SvgHsaPerksDashboard;
